import { render, staticRenderFns } from "./BackArrow.vue?vue&type=template&id=aca8ba34&scoped=true&"
import script from "./BackArrow.vue?vue&type=script&lang=js&"
export * from "./BackArrow.vue?vue&type=script&lang=js&"
import style0 from "./BackArrow.vue?vue&type=style&index=0&id=aca8ba34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca8ba34",
  null
  
)

export default component.exports